import React, { Component } from "react";
import { Table, Icon, Button, message, Spin } from "antd";
import moment from "moment";
import "antd/dist/antd.css";
import "./style.scss";
import HeaderBar from "./components/header-bar/index";
import { decodeLoganFile } from "../../../common/logan-decoder";
import { fetchS3FileViaProxy } from "../../../common/api";

const LOG_TYPE_NAMES = {
  1: "日志类型1", 2: "日志类型2", 3: "日志类型3",
  10: "原生端业务日志", 11: "Flutter端业务日志", 12: "Unity端业务日志",
};
function getLogTypeName(type) { return LOG_TYPE_NAMES[type] || "自定义业务日志"; }

const { Column } = Table;

const ICON_BY_PLATFORM = {
  "-1": <span>Unknown</span>,
  "0": (
    <span>
      <Icon type="android" /> | <Icon type="apple" />
    </span>
  ),
  "1": (
    <span>
      <Icon type="android" />
    </span>
  ),
  "2": (
    <span>
      <Icon type="apple" />
    </span>
  )
};

class ListPage extends Component {
  render() {
    const { filterConditions, tasks, updateFilterConditions, fetchTasks, loading, type } = this.props;
    return (
      <div className={"listpage-container"}>
        <HeaderBar
          filterConditions={filterConditions}
          updateFilterConditions={updateFilterConditions}
          fetchTasks={fetchTasks}
          type={type}
        />
        <div className={"table-container"}>
            {
              (() => {
                if (type === "native") {
                  return this.renderNativeColumns(tasks, loading);
                } else if (type === "web") {
                  return this.renderWebColumns(tasks, loading);
                }
              })()
            }
        </div>
      </div>
    );
  }

  renderNativeColumns = (tasks, loading) => {
    return (
      <Table
        size="middle"
        dataSource={tasks}
        loading={loading}
        pagination={false}
        scroll={{y: 650}}
        rowKey="taskId"
        locale={{emptyText: "没有已上传日志，请先触发崩溃上传或日志回捞，并检查 UID、设备 ID 和日期范围。"}}
      >
        <Column title="任务id" dataIndex="taskId" key="taskId" width="5%" />
        <Column title="AppId" dataIndex="appId" key="appId" width="10%"/>
        <Column title="AppVersion" dataIndex="appVersion" key="appVersion" width="6%"/>
        <Column title="设备标识" dataIndex="deviceId" key="deviceId" width="10%" />
        <Column title="UserId" dataIndex="userId" key="userId" width="8%" />
        <Column title="设备平台" dataIndex="platform" key="platform" width="5%" render={this.renderColumnPlatform} />
        <Column title="S3 Url" dataIndex="s3Url" key="s3Url" width="20%" render={(text, record) => this.renderColumnS3Url(record)} />
        <Column title="日志当天时间" dataIndex="logDate" key="logDate" width="9%" render={this.renderColumnLogDate} />
        <Column title="日志上报时间" dataIndex="addTime" key="addTime" width="9%" render={this.renderColumnAddTime} />
        <Column title="操作" dataIndex="action" width="18%" render={this.renderColumnAction} />
      </Table>
    );
  };

  renderWebColumns = (tasks, loading) => {
    return (
      <Table size="middle" dataSource={tasks} loading={loading} pagination={false} scroll={{y: 650}} rowKey="taskId">
        <Column title="设备标识" dataIndex="deviceId" key="deviceId" width="30%" />
        <Column title="日志来源" dataIndex="webSource" key="webSource" width="15%" render={this.renderColumnWebSource} />
        <Column title="环境信息" dataIndex="environment" key="environment" width="15%" render={this.renderColumnEnvironment} />
        <Column title="日志当天时间" dataIndex="logDate" key="logDate" width="10%" render={this.renderColumnLogDate} />
        <Column title="日志上报时间" dataIndex="addTime" key="addTime" width="10%" render={this.renderColumnAddTime} />
        <Column title="操作" dataIndex="action" width="10%" render={this.renderColumnAction} />
      </Table>
    );
  };

  renderColumnPlatform = platform => {
    return ICON_BY_PLATFORM[platform]
  };

  renderColumnWebSource = webSource => {
    if (webSource === null) {
      return <span>-</span>
    } else {
      return <span>{webSource}</span>
    }
  };

  renderColumnEnvironment = environment => {
    if (environment === null) {
      return <span>-</span>
    } else {
      return <span>{environment}</span>
    }
  };

  renderColumnLogDate = logDate => {
    return <div>{moment(logDate).format("YYYY-MM-DD")}</div>
  }

  renderColumnAddTime = addTime => {
    return <div>{moment(addTime).format("YYYY-MM-DD HH:mm:ss.SSS")}</div>;
  };

  getS3Url = (record) => {
    if (!record.s3Key) return null;
    if (record.s3Key.startsWith("http")) return record.s3Key;
    const base = record.s3BaseUrl ? (record.s3BaseUrl.endsWith("/") ? record.s3BaseUrl : record.s3BaseUrl + "/") : "";
    return base ? base + record.s3Key : record.s3Key;
  };

  renderColumnS3Url = (record) => {
    const url = this.getS3Url(record);
    if (!url) return <span>-</span>;
    const display = url.length > 50 ? "..." + url.slice(-47) : url;
    return (
      <span style={{display: "flex", alignItems: "center", gap: 4}}>
        <span title={url} style={{fontSize: "12px", wordBreak: "break-all", flex: 1}}>{display}</span>
        <Button icon="copy" size="small" onClick={() => this.handleCopyS3Url(url)} />
      </span>
    );
  };

  handleCopyS3Url = (url) => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(() => message.success("已复制"));
    } else {
      const input = document.createElement("input");
      input.value = url;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      message.success("已复制");
    }
  };

  renderColumnAction = (text, record, index) => {
    const {type} = this.props;
    if (type === "native") {
      return (
        <span>
          <Button onClick={this.toDetail(record.taskId, record)} style={{marginRight: 8}}>日志详情</Button>
          {record.s3Key && (
            <Button icon="download" onClick={() => this.handleS3Download(record.s3Key, record.s3BaseUrl)}>下载</Button>
          )}
        </span>
      );
    } else {
      return <Button onClick={this.toDetail(record.tasks, record)}>日志详情</Button>;
    }
  };

  handleS3Download = async (s3Key, s3BaseUrl) => {
    message.loading("正在下载并解密日志...", 0);
    try {
      const buffer = await fetchS3FileViaProxy(s3Key, s3BaseUrl);
      const logItems = decodeLoganFile(buffer);
      const text = logItems.map(item => {
        const time = item.l ? moment(parseInt(item.l)).format("YYYY-MM-DD HH:mm:ss.SSS") : "";
        const typeName = getLogTypeName(parseInt(item.f) || 0);
        return `[${time}] [${typeName}] ${item.c || ""}`;
      }).join("\n");
      // Trigger download
      const blob = new Blob([text], { type: "text/plain;charset=utf-8" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = (s3Key.split("/").pop() || "log") .replace(/\.[^.]+$/, "") + "_decrypted.log";
      a.click();
      URL.revokeObjectURL(a.href);
      message.destroy();
      message.success(`解密完成，共 ${logItems.length} 条日志`);
    } catch (e) {
      message.destroy();
      message.error("下载/解密失败: " + e.message);
    }
  };

  toDetail = (tasks, record) => () => {
    // If record has s3Key, use the S3 detail page
    if (record && record.s3Key) {
      this.props.history.push(`/s3-log-detail?tasks=${tasks}`);
    } else {
      const {detailUrlPrefix} = this.props;
      this.props.history.push(`${detailUrlPrefix}?tasks=${tasks}`);
    }
  };
}

export default ListPage;
